import { ManifestActions } from '../actions';

export const user = (state = null, actions) => {
  switch (actions.type) {
    case ManifestActions.GET_MANIFESTS:
      return Object.assign({}, state, { fetching: true });
    case ManifestActions.MANIFESTS_RECEIVED:
      return Object.assign({}, state, { fetching: false, list: actions.manifests });
    default:
      return state;
  }
}

export default user;


// WEBPACK FOOTER //
// ./src/reducers/manifests.js